import { useState, useRef, useEffect } from "react";
import { Icons } from "../../components/common/Icons";
import api from "../../services/api";
import T from '../../assets/styles/theme';
import "../../assets/styles/Intern/ChatWidget.css";

function ChatWidget() {
  const initMessages = [];

  const [msg, setMsg] = useState("");
  const end = useRef(null);
  const [messages, setMessages] = useState(initMessages);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);
  const send = async () => {
    if (!msg.trim()) return;
    try { await api.sendMessage("general", msg.trim()); } catch (e) { console.warn(e.message); }
    setMessages([...messages, { from: "me", name: "You", text: msg, time: "Just now" }]);
    setMsg("");
  };

  return (
    <div className="card animate-in delay-6">
      <div className="card-header">
        <div>
          <div className="card-title">Chat with HR</div>
          <div className="card-subtitle chatwidget-inline-1"><span className="status-dot active" /> HR Support</div>
        </div>
        <div className="view-only-badge chatwidget-dyn-1" style={{ "--chatwidget-1-background": T.successBg, "--chatwidget-1-border-color": T.successBorder, "--chatwidget-1-color": T.success }}>1:1 Chat</div>
      </div>
      <div className="card-body chatwidget-inline-2">
        <div className="chat-container">
          <div className="chat-messages">
            {messages.length === 0 ? (
              <div className="chat-empty">No messages yet. Say hello to HR.</div>
            ) : (
              messages.map((m, i) => (
                <div className={`chat-msg ${m.from}`} key={i}>
                  <div className="chat-msg-name">{m.name}</div>
                  <div className="chat-bubble">{m.text}</div>
                  <div className="chat-time">{m.time}</div>
                </div>
              ))
            )}
            <div ref={end} />
          </div>
          <div className="chat-input-row">
            <input className="chat-input" placeholder="Type a message..." value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} />
            <button className="chat-send-btn" onClick={send}><Icons.Send /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatWidget;
